import RatingAverage from './RatingAverage';

export default RatingAverage;
